import React from 'react'
import ServicesData from '../data/HomePage.json';
import { Row, Container, Col, Card, Image } from "react-bootstrap";
import { Link } from 'react-router-dom';

import readMore from "../Assets/services/read-more-icon.png"
import service1 from "../Assets/services/service-1.png"
import service2 from "../Assets/services/service-2.png"
import service3 from "../Assets/services/service-3.png"
import service4 from "../Assets/services/service-4.png"
import service5 from "../Assets/services/service-5.png"

import { FaLaptopCode } from "react-icons/fa";

const colors = ["#faeeee", "#eeeaf1", "#f2f4e8", "#e0f7fa"];

const getSeriveIcon = (name) => {
    switch (name.toLowerCase()) {
        case 'enterprise software development':
            return <div className='rounded p-2'><i class="fi fi-tr-display-code display-4" style={{ "color": "#df797c" }}></i></div>;
        case 'web application development':
            return <div className='rounded p-2'><i class="fi fi-tr-browser display-4" style={{ "color": "#9763bcff" }}></i></div >;
        case 'build & manage offshore teams':
            return <div className='rounded p-2'><i class="fi fi-tr-employees display-4" style={{ "color": "#8a9a53ff" }}></i></div >;
        default:
            return <div style={{ "background-color": "#df797c" }} className='rounded p-2'><FaLaptopCode size={40} /></div >;
    }
};

export default function Services() {
    const { services } = ServicesData;
    return (
        <section className='padding-section-large bg-gradient-1'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Do, <span className="text-gradient-1">Done Well</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Our software development services are designed for demanding requirements, evolving needs, and long-term growth. </h5>
                    </Col>
                </Row>
                <Row className="d-flex align-items-stretch servide-cards">
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="bg-hover hover-shadow logo-bg rounded-0">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Image src={service1} className='w-56' />
                                <Card.Title className='py-3'>Custom Software Development </Card.Title>
                                <Card.Text className="mb-5">From early concepts to enterprise-ready products, we develop applications that are robust, adaptable, and prepared for growth, with strong expertise in Ruby on Rails.</Card.Text>
                                <div className="mt-auto">
                                    <Link to="/custom_software"><Image src={readMore} className='w-34' /></Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 bg-hover hover-shadow">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Image src={service2} className='w-56' />
                                <Card.Title className='py-3'>Mobile Application Development </Card.Title>
                                <Card.Text className="mb-5">Fast, intuitive and built to perform, our mobile apps deliver seamless experiences across devices. </Card.Text>
                                <div className="mt-auto">
                                    <Link to="/mobile_application"><Image src={readMore} className='w-34' /></Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 bg-hover hover-shadow">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Image src={service4} className='w-56' />
                                <Card.Title className='py-3'>DevOps & Cloud Solutions </Card.Title>
                                <Card.Text className="mb-5">Accelerate releases, improve stability and keep pace with evolving demands through modern cloud and DevOps practices. </Card.Text>
                                <div className="mt-auto">
                                    <Link to="/devops_cloud"><Image src={readMore} className='w-34' /></Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 bg-hover hover-shadow">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Image src={service3} className='w-56' />
                                <Card.Title className='py-3'>Quality Assurance & Testing</Card.Title>
                                <Card.Text className="mb-5">We ensure everything performs exactly as expected, every time. </Card.Text>
                                <div className="mt-auto">
                                    <Link to="/qa_testing"><Image src={readMore} className='w-34' /></Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 bg-hover hover-shadow">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Image src={service5} className='w-56' />
                                <Card.Title className='py-3'>Offshore Team Setup </Card.Title>
                                <Card.Text className="mb-5">Bring in the right talent, plug into your workflow, and keep your momentum going without slowing down. </Card.Text>
                                <div className="mt-auto">
                                    <Link to="/offshore_team"><Image src={readMore} className='w-34' /></Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border bg-gradient-2 text-white">
                            <Card.Body className='p-4'>
                                <Card.Title className='py-3'>Expert Ruby on Rails development for fast, high-performing applications that scale with confidence. </Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
